import React, { useCallback, useMemo } from "react";
import { getDisplayName } from "data/constants";
import { usePersistSetting } from "hooks";
import {
    type NewFormTypeEnum,
    type DocumentFormDTO,
    NewFormType,
} from "data/types";
import Control from "./Control";

type Props = {
    newFormType: NewFormTypeEnum,
    form: DocumentFormDTO,
};

export type ApplyToAllProps = {
    renderControl: (Array<string>) => any,
};

const withApplyToAll = (WrappedComponent: ComponentType<any>) => {
    const HOC = (props: Props) => {
        const [applyToAll, setApplyToAll] = usePersistSetting({
            name: "applyToAll",
            defaultValue: false,
        });
        const shouldRender =
            props.newFormType === NewFormType.Document && props.multiple;

        // render control
        const renderControl = useCallback(
            (classNames = []) =>
                shouldRender && (
                    <Control
                        classNames={classNames}
                        applyToAll={applyToAll}
                        setApplyToAll={setApplyToAll}
                    />
                ),
            [shouldRender, applyToAll, setApplyToAll]
        );

        // create additional props
        const additionalProps = useMemo(
            () => ({
                value: applyToAll,
                renderControl,
            }),
            [applyToAll, renderControl]
        );

        return <WrappedComponent {...props} applyToAll={additionalProps} />;
    };
    HOC.displayName = `withApplyToAll(${getDisplayName(WrappedComponent)})`;
    return HOC;
};

export default withApplyToAll;
